

















import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';
import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { NAME as ZAKAZKA_ND } from '@/modules/servis/zakazka/nahradniDily/constants';
import { NAME as ZAKAZKA_PP } from '@/modules/servis/zakazka/pracovniPozice/constants';
import { NAME as ZAKAZKA_CV } from '@/modules/servis/zakazka/ciziVykony/constants';
import { PageMode } from '@/main/utils/pageMode';
import { getColumnsRowMapObject, ObjectType, Table } from '@/main/utils/table';
import { apiProvider } from '@/modules/servis/zakazka/api';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { POLOZKA_DRUH, POLOZKA_STATUS, SAGA_2_HLAV, SAGA_2_POL, PARTS, LABOUR, SAGA_ITEM_ADJUSTED } from '../constants';
import { showAlert } from '@/main/utils/notifications';

export default EditStoreMixin.extend({
	name: 'Saga2',
	data() {
		return {
			SAGA_2_HLAV,
			SAGA_2_POL,
			formatedDataSelectedRow: {} as any,
		};
	},
	computed: {
		...genVuexComputeds(store),
		upravaPolozkyDisabled(): boolean {
			return this.getEditableStatus(Number(this.formatedDataSelectedRow.S2StatusMeta));
		},
		saga2UnderText(): string {
			return `${this.LocalizePopisostatni('lblPocetClaim')} ${this.Saga2Pocet} ${this.LocalizePopisostatni('lblStatus')} ${this.Saga2Status}`;
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		...mapMutationsDvm(store.mutations),
		getEditableStatus(status: number) {
			switch (status) {
				case POLOZKA_STATUS.UZNANO: return true;
				case POLOZKA_STATUS.NAVRH: return false;
				case POLOZKA_STATUS.ZMENA: return false;
				case POLOZKA_STATUS.ERR_STATE: return true;
				case POLOZKA_STATUS.ZAMITNUTO: return false;
				default: return true;
			}
		},
		polSelected(data: any) {
			this.formatedDataSelectedRow = getColumnsRowMapObject((this.dependentTables[SAGA_2_POL] as Table).columns, data, ObjectType.propertyName);
		},
		async upravaPolozky() {
			const StartTime = performance.now();
			const { data } = await apiProvider.upravaPolozkyCheck(this.formatedDataSelectedRow);
			if (data.UserMessagesList) {
				return null;
			}
			if (data.ZakXXId === -1 && data.PolozStatus === POLOZKA_STATUS.ZAMITNUTO) {
				// TODO: vymazat polozku a refresh
			} else {
				switch (data.PolozStatus) {
					case POLOZKA_STATUS.ZAMITNUTO: {
						switch (data.DruhPoloz) {
							case POLOZKA_DRUH.ND: {
								await openEdit(ZAKAZKA_ND, PageMode.EDIT, { props: true, id: data.ZakXXId as any, saga2Status: POLOZKA_STATUS.ZAMITNUTO });
								break;
							}
							case POLOZKA_DRUH.PP: {
								await openEdit(ZAKAZKA_PP, PageMode.EDIT, { props: true, id: data.ZakXXId as any, saga2Status: POLOZKA_STATUS.ZAMITNUTO });
								break;
							}
							case POLOZKA_DRUH.CV: {
								await openEdit(ZAKAZKA_CV, PageMode.EDIT, { props: true, id: data.ZakXXId as any, saga2Status: POLOZKA_STATUS.ZAMITNUTO });
								break;
							}
							default:
						}
						break;
					}
					case POLOZKA_STATUS.NAVRH: {
						// TODO: Test pseudo nahrad
						switch (data.DruhPoloz) {
							case POLOZKA_DRUH.ND: {
								await openEdit(ZAKAZKA_ND, PageMode.CREATE, {
									props: true,
									filter: {
										ZakazkaId: this.ZakazkaId,
									},
									polozkaText: data.PolozkaText,
									polozkaNr: data.PolozkaNr,
									mnozstvi: data.S2MnozstviVj,
									polozkaId: data.PolId,
									saga2Status: POLOZKA_STATUS.NAVRH,
									pseudonahradaMap: data.PSNDnahradaMap,
									vyrobekndOzn: data.S2VyrobekndOzn,
								});
								break;
							}
							case POLOZKA_DRUH.PP: {
								await openEdit(ZAKAZKA_PP, PageMode.CREATE,
									{
										props: true,
										filter: {
											ZakazkaId: this.ZakazkaId,
										},
										zarmobilPzn: data.ZarmobilPzn,
										strnakltypOzn: data.StrnakltypOzn,
										polozkaText: data.PolozkaText,
										polozkaNr: data.PolozkaNr,
										pcPevna: data.PcPevna,
										lakJdnPoc: data.LakJdnPoc,
										emisePzn: data.EmisePzn,
										dphSzbOzn: data.DphSzbOzn,
										cinnostPrp: data.CinnostPrp,
										casJdnPoc: data.CasJdnPoc,
										saga2Status: POLOZKA_STATUS.NAVRH,
										polozkaId: data.PolId,
									});
								break;
							}
							case POLOZKA_DRUH.CV: {
								await openEdit(ZAKAZKA_CV, PageMode.CREATE,
									{
										props: true,
										filter: {
											ZakazkaId: this.ZakazkaId,
										},
										polozkaNr: data.PolozkaNr,
										polozkaText: data.PolozkaText,
										dNc: data.S2GarPcCelkGd,
										saga2Status: POLOZKA_STATUS.NAVRH,
										polozkaId: data.PolId,
									});
								break;
							}
							default:
						}
						break;
					}
					case POLOZKA_STATUS.ZMENA: {			
						switch (data.DruhPoloz) {
							case POLOZKA_DRUH.ND: {
								if(await this.isAnySplitPartyInoviced(data.ZakazkaId, data.ZakXXId, PARTS) == true){
										showAlert({
										message: this.LocalizeChyboveHlasky('Can_Not_Adjust_Saga_Item'),
										title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
										options: {
											type: 'info',
										},
									});
									return;
								}

								openEdit(
									ZAKAZKA_ND,
									PageMode.EDIT,
									{ props: true, id: data.ZakXXId as any, mnozstvi: data.S2MnozstviVj, polId: data.PolId, saga2Status: POLOZKA_STATUS.ZMENA },
								);
								break;
							}
							case POLOZKA_DRUH.PP: {
								if(await this.isAnySplitPartyInoviced(data.ZakazkaId, data.ZakXXId, LABOUR) == true){
										showAlert({
										message: this.LocalizeChyboveHlasky('Can_Not_Adjust_Saga_Item'),
										title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
										options: {
											type: 'info',
										},
									});
								return;
								}
								openEdit(ZAKAZKA_PP, PageMode.EDIT, { props: true, id: data.ZakXXId as any, mnozstvi: data.S2Mnozstvi, saga2Status: POLOZKA_STATUS.ZMENA });
								break;
							}
							case POLOZKA_DRUH.CV: {
								openEdit(ZAKAZKA_CV, PageMode.EDIT, { props: true, id: data.ZakXXId as any, saga2Status: POLOZKA_STATUS.ZMENA });
								break;
							}
							default:
						}
						break;
					}
					default:
				}
			}
			let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'Order', SAGA_ITEM_ADJUSTED, seconds);
		},

		async isAnySplitPartyInoviced(orderId:number|null, itemId:number|null, itemType:string){
			const { data: isAnySplitPartyInoviced }=  await apiProvider.isAnySplitPartyInoviced(orderId, itemId, itemType);
			return isAnySplitPartyInoviced;
		},
	},
});
